import React from 'react';
import { Row, Col } from 'reactstrap';
import AnalyticsSection from '../components/analytics_section';
import OverviewCard from '../components/overview_card';
import BarChartCard from '../components/barchart_card';
import MetricSummaryRow from '../components/metric_summary';
import { formatNumber } from '../data';
import '../style.css';

const AvodTab = ({ 
  avodDateRange, 
  setAvodDateRange, 
  avodRevenue, 
  avodFillRate, 
  avodCPM, 
  avodRequests,
  avodImpressions,
  isLoading = false,
}) => {
  const isContentPartner = localStorage.getItem('role_id') == 8;

  return (
    <>
      <AnalyticsSection 
        title="Quick Overview" 
        dateRange={avodDateRange}
        onDateChange={setAvodDateRange}
        reportLink="/new-analytics/avod"
        isQuickOverview={true}
        hideReportLink={isContentPartner}
      >
        <Row>
          <Col md={4}>
            <OverviewCard
              title="Revenue"
              value={`$${formatNumber(avodRevenue.netValue)}`}
              percentageChange={avodRevenue.percentageChange}
              formattedPercentageChange={avodRevenue.formattedPercentageChange}
              link='/report/revenues_report'
              showLink={true}
              isLoading={isLoading}
            />
          </Col>
          <Col md={4} className='border-column'>
            <OverviewCard
              title="Fill Rate"
              value={`${formatNumber(avodFillRate.netValue)}%`}
              percentageChange={avodFillRate.percentageChange}
              formattedPercentageChange={avodFillRate.formattedPercentageChange}
              isLoading={isLoading}
            />
          </Col>
          <Col md={4}>
            <OverviewCard
              title="CPM"
              value={`$${formatNumber(avodCPM.netValue)}`}
              percentageChange={avodCPM.percentageChange}
              formattedPercentageChange={avodCPM.formattedPercentageChange}
              isLoading={isLoading}
            />
          </Col>
        </Row>
        {!isContentPartner && (
          <MetricSummaryRow
            metrics={[
              {
                label: "revenue",
                value: `$${formatNumber(avodRevenue.netValue)}`,
                percentageChange: avodRevenue.percentageChange,
                period: avodDateRange[0].label
              },
              {
                label: "fill rate",
                value: `${formatNumber(avodFillRate.netValue)}%`,
                percentageChange: avodFillRate.percentageChange,
                period: avodDateRange[0].label
              },
              {
                label: "cpm",
                value: `$${formatNumber(avodCPM.netValue)}`,
                percentageChange: avodCPM.percentageChange,
                period: avodDateRange[0].label
              }
            ]}
          />
        )}
      </AnalyticsSection>

      <AnalyticsSection 
        title="AVOD Overview" 
        dateRange={avodDateRange}
        onDateChange={setAvodDateRange}
        reportLink="/new-analytics/avod"
        hideReportLink={isContentPartner}
      >
        <Row>
          <Col md={6} className="mb-3">
            <BarChartCard
              title="Revenue"
              value={`$${formatNumber(avodRevenue.netValue)}`}
              percentageChange={avodRevenue.percentageChange}
              formattedPercentageChange={avodRevenue.formattedPercentageChange}
              xAxis={avodRevenue.xAxis}
              yAxis={avodRevenue.yAxis}
              dataName="Revenue"
              isLoading={isLoading}
            />
          </Col>
          <Col md={6} className="mb-3">
            <BarChartCard
              title="CPM"
              value={`$${formatNumber(avodCPM.netValue)}`}
              percentageChange={avodCPM.percentageChange}
              formattedPercentageChange={avodCPM.formattedPercentageChange}
              xAxis={avodCPM.xAxis}
              yAxis={avodCPM.yAxis}
              dataName="CPM"
              isLoading={isLoading}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6} className="mb-3">
            <BarChartCard
              title="Impressions"
              value={formatNumber(avodImpressions.netValue)}
              percentageChange={avodImpressions.percentageChange}
              formattedPercentageChange={avodImpressions.formattedPercentageChange}
              xAxis={avodImpressions.xAxis}
              yAxis={avodImpressions.yAxis}
              dataName="Impressions"
              isLoading={isLoading}
            />
          </Col>
          <Col md={6} className="mb-3">
            <BarChartCard
              title="Requests"
              value={formatNumber(avodRequests.netValue)}
              percentageChange={avodRequests.percentageChange}
              formattedPercentageChange={avodRequests.formattedPercentageChange}
              xAxis={avodRequests.xAxis}
              yAxis={avodRequests.yAxis}
              dataName="Requests"
              isLoading={isLoading}
            />
          </Col>
          <Col md={6} className="mb-3">
            <BarChartCard
              title="Fill Rate"
              value={`${formatNumber(avodFillRate.netValue)}%`}
              percentageChange={avodFillRate.percentageChange}
              formattedPercentageChange={avodFillRate.formattedPercentageChange}
              xAxis={avodFillRate.xAxis}
              yAxis={avodFillRate.yAxis}
              dataName="Fill Rate"
              isLoading={isLoading}
            />
          </Col>
        </Row>
      </AnalyticsSection>
    </>
  );
};

export default AvodTab;